var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilities3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_13_1",
    "data-name": "Component 13 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 134.377,
    height: 97.504,
    viewBox: "0 0 134.377 97.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 134.377,
    height: 97.504,
    fill: "none",
    stroke: "#e0e1e5",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95-2",
    "data-name": "Rectangle 95",
    width: 134.377,
    height: 97.504,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M99.438,52.97C90.45,58.958,88.751,73.262,88.751,73.262c4.509.5,6.964-.662,6.964-.662a22.247,22.247,0,0,1,15.1-12.189c11.042-2.388,9.241,4.178,19.84,0m-78.8,12.738c1.045-1.633,7.643-25.6,11.323-27.8,5.882-3.583,4.7-12.481-4.805-12.656l-36.5-.724c-8.214-.156-11.04,6.832-6.639,11.356A28.641,28.641,0,0,0,4.3,55.213C2.22,59.382-1.186,67.384,1.867,71.467c1.324,1.769,3.583,1.522,8.6,1.676v.006H77.185m5.259-53.105,5.761,18.162a4.348,4.348,0,0,0-2.333,2.656L72.183,73.149m56.284-11.827c1.447-.428,7.714-2.271-.1-8.631-5.859-4.775-13.231-5.134-18.86-3.828.869-3.75-1.176-7.829-6.016-7.649L90.418,12.224c2.2,1.568,8.6,3.519,9,.893L101.08,2.311C101.387.273,98.714.684,96.664.684c-3.343,0-8.733.575-9.624,4.051a4.441,4.441,0,0,0-8.415,1.894",
    transform: "translate(0.756 0.757)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M45.607,44.472A17.324,17.324,0,1,0,78.358,33.378",
    transform: "translate(53.024 38.807)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M57.677,49.3a8.357,8.357,0,1,1,8.508-8.2A8.348,8.348,0,0,1,57.677,49.3Z",
    transform: "translate(57.52 37.893)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M12.14,20.791c7.718-.51,20.491,1.138,19.887,17.779",
    transform: "translate(14.114 24.084)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 10.85,
    transform: "translate(52.633 46.486)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x1: 12.197,
    y2: 7.437,
    transform: "translate(71.841 12.08)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M5.55,38.629a17.159,17.159,0,0,0,33.06,0",
    transform: "translate(6.453 44.912)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M23.269,38.629a8.122,8.122,0,0,1-13.16,0",
    transform: "translate(11.753 44.912)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M10.11,38.629a8.12,8.12,0,0,0,13.157,0",
    transform: "translate(11.754 44.912)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45-2",
    "data-name": "Group 45",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236-2",
    "data-name": "Path 236",
    d: "M99.438,52.97C90.45,58.958,88.751,73.262,88.751,73.262c4.509.5,6.964-.662,6.964-.662a22.247,22.247,0,0,1,15.1-12.189c11.042-2.388,9.241,4.178,19.84,0m-78.8,12.738c1.045-1.633,7.643-25.6,11.323-27.8,5.882-3.583,4.7-12.481-4.805-12.656l-36.5-.724c-8.214-.156-11.04,6.832-6.639,11.356A28.641,28.641,0,0,0,4.3,55.213C2.22,59.382-1.186,67.384,1.867,71.467c1.324,1.769,3.583,1.522,8.6,1.676v.006H77.185m5.259-53.105,5.761,18.162a4.348,4.348,0,0,0-2.333,2.656L72.183,73.149m56.284-11.827c1.447-.428,7.714-2.271-.1-8.631-5.859-4.775-13.231-5.134-18.86-3.828.869-3.75-1.176-7.829-6.016-7.649L90.418,12.224c2.2,1.568,8.6,3.519,9,.893L101.08,2.311C101.387.273,98.714.684,96.664.684c-3.343,0-8.733.575-9.624,4.051a4.441,4.441,0,0,0-8.415,1.894",
    transform: "translate(0.756 0.757)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237-2",
    "data-name": "Path 237",
    d: "M45.607,44.472A17.324,17.324,0,1,0,78.358,33.378",
    transform: "translate(53.024 38.807)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238-2",
    "data-name": "Path 238",
    d: "M57.677,49.3a8.357,8.357,0,1,1,8.508-8.2A8.348,8.348,0,0,1,57.677,49.3Z",
    transform: "translate(57.52 37.893)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239-2",
    "data-name": "Path 239",
    d: "M12.14,20.791c7.718-.51,20.491,1.138,19.887,17.779",
    transform: "translate(14.114 24.084)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57-2",
    "data-name": "Line 57",
    x2: 10.85,
    transform: "translate(52.633 46.486)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58-2",
    "data-name": "Line 58",
    x1: 12.197,
    y2: 7.437,
    transform: "translate(71.841 12.08)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240-2",
    "data-name": "Path 240",
    d: "M5.55,38.629a17.159,17.159,0,0,0,33.06,0",
    transform: "translate(6.453 44.912)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241-2",
    "data-name": "Path 241",
    d: "M23.269,38.629a8.122,8.122,0,0,1-13.16,0",
    transform: "translate(11.753 44.912)",
    fill: "none",
    stroke: "#00a6fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242-2",
    "data-name": "Path 242",
    d: "M10.11,38.629a8.12,8.12,0,0,0,13.157,0",
    transform: "translate(11.754 44.912)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilities3);
export default __webpack_public_path__ + "static/media/utilities3.b8559619fff96bd667b8b96595c6e7e1.svg";
export { ForwardRef as ReactComponent };